import { useIntl } from '@capsicum/common';
import { CheckboxInput, SkeletonItem } from '@capsicum/common-web';
import { countryRegistrationStepAtom } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';

import { CheckboxText, ExternalLink } from './Register.styled';

export const TermsAndConditions = () => {
	const { $t } = useIntl();
	const { countryPrivacyPolicy, countryTermsAndConditions, isPolicyLoading, ncwTermsAndConditions } =
		useAtomValue(countryRegistrationStepAtom);

	return isPolicyLoading ? (
		<SkeletonItem height={42} width="100%" />
	) : (
		<CheckboxInput name="termsAndConditions" testID="registration-termsAndConditions-checkbox">
			<CheckboxText>
				{$t<JSX.Element>('auth.ncwTermsAndConditions', {
					ncwTermsLink: chunks => (
						<ExternalLink href={ncwTermsAndConditions || ''} rel="noreferrer" target="_blank">
							{chunks}
						</ExternalLink>
					),
					policyLink: chunks => (
						<ExternalLink href={countryPrivacyPolicy} rel="noreferrer" target="_blank">
							{chunks}
						</ExternalLink>
					),
					termsLink: chunks => (
						<ExternalLink href={countryTermsAndConditions || ''} rel="noreferrer" target="_blank">
							{chunks}
						</ExternalLink>
					)
				})}
			</CheckboxText>
		</CheckboxInput>
	);
};
